import { render, staticRenderFns } from "./PesananSuksesView.vue?vue&type=template&id=7d945e84"
import script from "./PesananSuksesView.vue?vue&type=script&lang=js"
export * from "./PesananSuksesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports